<div
  [pTooltip]="template || name"
  [escape]="false"
  tooltipPosition="left"
  tooltipStyleClass="u-tooltip {{ colorClassName[color] }}"
  class="link-indicator"
  [ngClass]="color"
></div>
